// extracted by mini-css-extract-plugin
module.exports = {"chartPieExample":"index_chartPieExample_jrXqN"};